module.exports = __webpack_public_path__ + "static/media/IR.d8204807.svg";